import { defineMessages } from 'react-intl';

const scope = 'cb.screens.ReservedCoupon';

export default defineMessages({
  reservedCoupon: {
    id: `${scope}.reservedCoupon`,
    defaultMessage: 'This Coupon Is Reserved',
  },
  expiresIn: {
    id: `${scope}.expiresIn`,
    defaultMessage: 'Expires in',
  },
  price: {
    id: `${scope}.price`,
    defaultMessage: 'Price:',
  },
  deal: {
    id: `${scope}.deal`,
    defaultMessage: 'Deal:',
  },
  nowPlusTax: {
    id: `${scope}.nowPlusTax`,
    defaultMessage: 'Now: {price} plus tax',
  },
  instructions: {
    id: `${scope}.instructions`,
    defaultMessage: 'Please present this coupon to the business and then click Redeem.',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Close',
  },
  redeemNow: {
    id: `${scope}.redeemNow`,
    defaultMessage: 'Redeem Now',
  },
  redeemNowModalTitle: {
    id: `${scope}.redeemNowModalTitle`,
    defaultMessage: 'Redeem Now?',
  },
  redeemNowModalMessage: {
    id: `${scope}.redeemNowModalMessage`,
    defaultMessage: 'Please ensure that the business has viewed and verified this coupon before redeeming.',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'No',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  payWithPoints: {
    id: `${scope}.payWithPoints`,
    defaultMessage: 'Pay With Points',
  },
});
